// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3mP5t","footer":"ModalUpdate_footer__Lip6S"};